import {
  ContextSnippet,
  CreateContextSnippetPayload,
  UpdateContextSnippetPayload,
  PreviewContextSnippetPayload,
  PreviewContextSnippetResponse,
} from '@/types/api';
import { getApiBaseUrl, handleResponse } from './client';

// Context Snippet API calls
export async function getContextSnippets(): Promise<ContextSnippet[]> {
  const response = await fetch(`${getApiBaseUrl()}/context-snippets`);
  return handleResponse<ContextSnippet[]>(response);
}

export async function createContextSnippet(
  payload: CreateContextSnippetPayload,
): Promise<ContextSnippet> {
  const response = await fetch(`${getApiBaseUrl()}/context-snippets`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return handleResponse<ContextSnippet>(response);
}

export async function updateContextSnippet(
  id: string,
  payload: UpdateContextSnippetPayload,
): Promise<ContextSnippet> {
  const response = await fetch(`${getApiBaseUrl()}/context-snippets/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return handleResponse<ContextSnippet>(response);
}

export async function deleteContextSnippet(id: string): Promise<void> {
  const response = await fetch(`${getApiBaseUrl()}/context-snippets/${id}`, {
    method: 'DELETE',
  });
  await handleResponse<void>(response);
}

export async function previewContextSnippet(
  payload: PreviewContextSnippetPayload,
): Promise<PreviewContextSnippetResponse> {
  const response = await fetch(
    `${getApiBaseUrl()}/context-snippets/preview-output`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
  );
  return handleResponse<PreviewContextSnippetResponse>(response);
}